import * as ObjectTypeIds from 'customer-data-objects/constants/ObjectTypeIds';
import * as ObjectTypes from 'customer-data-objects/constants/ObjectTypes';
// The supported objectTypeIds are driven by what the ML model supports and what it was trained on.
// For reference this is the supported object types for v1 of the action recommender model:
// https://git.hubteam.com/HubSpot/ProductionModels/blob/6604bc4a1cd4490700b29416d008f90c3dceb208/AutomationNewActionRecommendation/AutomationNewActionRecommendation-v1/modules/core/constants.py#L2
// This list is further trimmed down to CRMObjectType and legacyObjectType supported objectTypeIds
export const actionRecommendationSupportedObjectTypeIds = {
  [ObjectTypeIds.CONTACT_TYPE_ID]: ObjectTypes.CONTACT,
  [ObjectTypeIds.COMPANY_TYPE_ID]: ObjectTypes.COMPANY,
  [ObjectTypeIds.DEAL_TYPE_ID]: ObjectTypes.DEAL,
  [ObjectTypeIds.ENGAGEMENT_TYPE_ID]: ObjectTypes.ENGAGEMENT,
  [ObjectTypeIds.TICKET_TYPE_ID]: ObjectTypes.TICKET,
  [ObjectTypeIds.PRODUCT_TYPE_ID]: ObjectTypes.PRODUCT,
  [ObjectTypeIds.LINE_ITEM_TYPE_ID]: ObjectTypes.LINE_ITEM,
  [ObjectTypeIds.CONVERSATION_TYPE_ID]: ObjectTypes.CONVERSATION,
  [ObjectTypeIds.QUOTE_TYPE_ID]: ObjectTypes.QUOTE,
  [ObjectTypeIds.FEEDBACK_SUBMISSION_TYPE_ID]: ObjectTypes.FEEDBACK_SUBMISSION,
  [ObjectTypeIds.TASK_TYPE_ID]: ObjectTypes.TASK,
  [ObjectTypeIds.OBJECT_LIST_TYPE_ID]: ObjectTypes.OBJECT_LIST
};